



import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
@Component
export default class Macro extends Vue {
    @Prop({ default: "" }) element!: any;
    @Prop() type!: string;
    @Prop({ default: "" }) displayType!: string;

    display = 0;
    interval: any;
    timeout: any;

    mounted() {
        this.calculateMacro();
        this.timeout = setTimeout(() => {
            this.calculateMacro();
            this.interval = setInterval(this.calculateMacro, 60000);
        }, (60 - moment().seconds()) * 1000);
    }

    beforeDestroy() {
        clearInterval(this.interval);
        clearTimeout(this.timeout);
    }

    calculateMacro() {
        const elementTime = moment(this.element.trim(), "DD-MM-YYYY hh:mm:ss");
        const curTime = moment();

        if (this.type === "CDOWNDAYS") this.display = elementTime.startOf("day").diff(curTime.startOf("day"), "days");
        if (this.type === "CLOCALDAYS") this.display = curTime.startOf("day").diff(elementTime.startOf("day"), "days");
        if (this.type === "CGLOBALDAYS") this.display = curTime.startOf("day").diff(elementTime.startOf("day"), "days");
        if (this.type === "CDOWNHOURS") this.display = elementTime.diff(curTime, "hours");
        if (this.type === "CDOWNMINUTES") this.display = elementTime.diff(curTime, "minutes");
        if (this.type === "WEEKNUMBER") this.display = curTime.isoWeek();

        if (this.type === "CDOWNDHM" || this.type === "CUPDHM") {
            let time = elementTime.diff(curTime);
            if (this.type === "CUPDHM") time = curTime.diff(elementTime);

            if (this.displayType === "DAYS") this.display = moment.duration(time).days();
            if (this.displayType === "HOURS") this.display = moment.duration(time).hours();
            if (this.displayType === "MINUTES") this.display = moment.duration(time).minutes();
        }

        if (this.display < 0) this.display = 0;
    }
}
